module.exports = __webpack_public_path__ + "static/bamboo-5d767a9c3320dbd205de318b474163f8.svg";